import { useCallback } from 'react';

import { useTranslations } from '@/i18n/use-locale';

export interface VideoDecisionWording {
  rejectAction: string;
  approveBody: string;
  rejectHint: string;
  rejected: string;
}

/**
 * What the decision flow says about a video introduction, where the document queue's
 * own words would be wrong: approving shows the video to clubs (never on the public
 * page), and rejecting deletes no credential item — it only keeps the video hidden.
 */
export function useVideoDecisionWording(): (talentName: string) => VideoDecisionWording {
  const t = useTranslations('admin.documents.video');
  return useCallback(
    (talentName) => ({
      rejectAction: t('rejectAction'),
      approveBody: t('approveBody', { name: talentName }),
      rejectHint: t('rejectHint'),
      rejected: t('rejected'),
    }),
    [t],
  );
}
